import { ButtonQuaternary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { MouseEvent } from "react"

export const WorkspaceHomeTertiaryItem = ({
    title,
    Icon,
    onClick,
}: {
    title: string
    Icon: Icons.IconComponent
    onClick: (e: MouseEvent) => void
}) => {
    return (
        <div className="flex items-center select-none relative">
            <Icons.Icon Icon={Icons.ArrowRight} className="text-gray-400" />
            <ButtonQuaternary
                title={title}
                RightIcon={Icon}
                rightIconClassName="text-gray-300"
                onClick={onClick}
            />
        </div>
    )
}
